import type { RangePreset } from '@/types';

const PRESETS: { value: RangePreset; label: string }[] = [
    { value: '7d', label: '7 days' },
    { value: '30d', label: '30 days' },
    { value: '90d', label: '90 days' },
    { value: 'all', label: 'All time' },
];

export interface RangeChipsProps {
    value: RangePreset;
    onChange: (preset: RangePreset) => void;
    disabled?: boolean;
}

/** Date-range filter shared by every metric surface (§4.5). */
export default function RangeChips({ value, onChange, disabled = false }: RangeChipsProps) {
    return (
        <div
            role="group"
            aria-label="Date range"
            className="inline-flex items-center gap-1 rounded-full border border-[#E0E0E0] bg-white p-1"
        >
            {PRESETS.map((preset) => {
                const isActive = preset.value === value;
                return (
                    <button
                        key={preset.value}
                        type="button"
                        disabled={disabled}
                        aria-pressed={isActive}
                        onClick={() => onChange(preset.value)}
                        className={`rounded-full px-3 py-1.5 text-[13px] font-medium transition-colors disabled:opacity-50 sm:px-4 ${
                            isActive ? 'bg-secondary text-white' : 'text-[#6b6b6b] hover:bg-[#f5f5f5]'
                        }`}
                    >
                        {preset.label}
                    </button>
                );
            })}
        </div>
    );
}
